<template>
  <div class="full-name-container">
    <a-form-item class="input">
      <label
        v-if="firstNameLabel"
        class="input-label first-name-input-label"
        :class="{required}"
        for="firstName"
      >{{firstNameLabel}}</label>
      <text-input
        name="firstName"
        :disabled="disabled"
        :placeholder="firstNamePlaceholder"
        @change="onFirstNameChange"
        v-decorator="[
          'firstName',
          {
            rules: [
              {
                required: this.required,
                message: $t('validation.required'),
              },
            ],
            initialValue: value.firstName,
          },
        ]"
      />
    </a-form-item>
    <spacer type="small" />
    <a-form-item class="input">
      <label
        v-if="lastNameLabel"
        class="input-label last-name-input-label"
        :class="{required}"
        for="lastName"
      >{{lastNameLabel}}</label>
      <text-input
        name="lastName"
        :placeholder="lastNamePlaceholder"
        @change="onLastNameChange"
        :disabled="disabled"
        v-decorator="[
          'lastName',
          {
            rules: [
              {
                required: this.required,
                message: $t('validation.required'),
              },
            ],
            initialValue: value.lastName,
          },
        ]"
      />
    </a-form-item>
  </div>
</template>

<script>
import capitalize from 'lodash.capitalize';

import TextInput from '@/components/common/TextInput.vue';
import Spacer from '@/components/common/Spacer.vue';

export default {
  components: {
    TextInput,
    Spacer,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      fieldName: String,
      lastName: String,
    },
    disabled: Boolean,
    required: {
      type: Boolean,
      default: false,
    },
  },
  inject: {
    theme: {
      type: Object,
      default: {},
    },
  },
  computed: {
    firstNameLabel() {
      return this.theme.mode !== 'label' ? '' : this.$t('first.name');
    },
    firstNamePlaceholder() {
      return this.theme.mode === 'label' ? '' : this.$t('first.name');
    },
    lastNameLabel() {
      return this.theme.mode !== 'label' ? '' : this.$t('last.name');
    },
    lastNamePlaceholder() {
      return this.theme.mode === 'label' ? '' : this.$t('last.name');
    },
  },
  methods: {
    onFirstNameChange(e) {
      this.onChange('firstName', e);
    },
    onLastNameChange(e) {
      this.onChange('lastName', e);
    },
    onChange(fieldName, value) {
      const ev = {
        firstName: this.value.firstName,
        lastName: this.value.lastName,
        [fieldName]: capitalize(value),
      };
      this.$emit('change', ev);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/breakpoints';

.full-name-container {
  width: 100%;
  display: flex;
}

.input {
  flex: 1;
}

.input-label {
  text-align: left;
}

@media (max-width: $login-base-breakpoint) {
  .full-name-container {
    flex-direction: column;
  }
}
</style>

<style lang="scss">
.full-name-container {
  .ant-form-item-children {
    display: flex;
    flex-direction: column;
  }
}
</style>